/**
 * At the moment our bad words dataset is a modified
 * version of the offensive words list made available
 * from Carnegie Mellon University School of Computer
 * Science @: https://www.cs.cmu.edu/~biglou/resources/bad-words.txt
 *
 */
const badwords = [
	'abbo',
	'abo',
	'addict',
	'addicts',
	'alligatorbait',
	'analannie',
	'analsex',
	'argie',
	'arse',
	'arsehole',
	'assassin',
	'assassinate',
	'assassination',
	'assault',
	'assbagger',
	'assblaster',
	'assclown',
	'asscowboy',
	'asses',
	'assfuck',
	'assfucker',
	'asshat',
	'asshole',
	'assholes',
	'asshore',
	'assjockey',
	'asskiss',
	'asskisser',
	'assklown',
	'asslick',
	'asslicker',
	'asslover',
	'assman',
	'assmonkey',
	'assmunch',
	'assmuncher',
	'asspacker',
	'asspirate',
	'asspuppies',
	'assranger',
	'asswhore',
	'asswipe',
	'athletesfoot',
	'backdoorman',
	'backseat',
	'badfuck',
	'balllicker',
	'ballsack',
	'banging',
	'barelylegal',
	'barface',
	'barfface',
	'bast',
	'bastard',
	'bazongas',
	'bazooms',
	'beaner',
	'beastality',
	'beastial',
	'beastiality',
	'beatoff',
	'beat-off',
	'beatyourmeat',
	'bestial',
	'bestiality',
	'biatch',
	'bicurious',
	'bigass',
	'bigbastard',
	'bigbutt',
	'bisexual',
	'bi-sexual',
	'bitch',
	'bitcher',
	'bitches',
	'bitchez',
	'bitchin',
	'bitching',
	'bitchslap',
	'bitchy',
	'biteme',
	'blackout',
	'blacks',
	'blow',
	'blowjob',
	'boang',
	'bohunk',
	'bollick',
	'bollock',
	'bomb',
	'bombers',
	'bombing',
	'bombs',
	'bomd',
	'bondage',
	'boner',
	'bong',
	'boob',
	'boobies',
	'boobs',
	'booby',
	'boody',
	'boom',
	'boong',
	'boonga',
	'boonie',
	'booty',
	'bootycall',
	'bountybar',
	'bra',
	'brea5t',
	'breast',
	'breastjob',
	'breastlover',
	'breastman',
	'brothel',
	'bugger',
	'buggered',
	'buggery',
	'bullcrap',
	'bulldike',
	'bulldyke',
	'bullshit',
	'bumblefuck',
	'bumfuck',
	'bunga',
	'bunghole',
	'butchbabes',
	'butchdike',
	'butchdyke',
	'buttbang',
	'butt-bang',
	'buttface',
	'buttfuck',
	'butt-fuck',
	'buttfucker',
	'butt-fucker',
	'buttfuckers',
	'butt-fuckers',
	'butthead',
	'buttman',
	'buttmunch',
	'buttmuncher',
	'buttpirate',
	'buttplug',
	'buttstain',
	'byatch',
	'cacker',
	'cameljockey',
	'cameltoe',
	'carpetmuncher',
	'carruth',
	'chav',
	'cherrypopper',
	'chickslick',
	'chinaman',
	'chinamen',
	'chink',
	'chinky',
	'choad',
	'chode',
	'clamdigger',
	'clamdiver',
	'clit',
	'clitoris',
	'clogwog',
	'cockblock',
	'cockblocker',
	'cockcowboy',
	'cockfight',
	'cockhead',
	'cockknob',
	'cocklicker',
	'cocklover',
	'cocknob',
	'cockqueen',
	'cockrider',
	'cocksman',
	'cocksmith',
	'cocksmoker',
	'cocksucer',
	'cocksuck ',
	'cocksucked ',
	'cocksucker',
	'cocksucking',
	'cocktail',
	'cocktease',
	'cohee',
	'coitus',
	'commie',
	'communist',
	'condom',
	'conservative',
	'conspiracy',
	'coolie',
	'cooly',
	'coon',
	'copulate',
	'cornhole',
	'corruption',
	'cra5h',
	'crabs',
	'crack',
	'crackpipe',
	'crackwhore',
	'crack-whore',
	'crap',
	'crapola',
	'crapper',
	'crappy',
	'crash',
	'creamy',
	'crime',
	'criminal',
	'criminals',
	'crotchjockey',
	'crotchmonkey',
	'crotchrot',
	'cum',
	'cumbubble',
	'cumfest',
	'cumjockey',
	'cumm',
	'cummer',
	'cumquat',
	'cumqueen',
	'cumshot',
	'cunilingus',
	'cunillingus',
	'cunn',
	'cunnilingus',
	'cunntt',
	'cunt',
	'cunteyed',
	'cuntfuck',
	'cuntfucker',
	'cuntlick ',
	'cuntlicker ',
	'cuntlicking ',
	'cuntsucker',
	'cybersex',
	'cyberslimer',
	'dago',
	'dammit',
	'damn',
	'damnation',
	'damnit',
	'darkie',
	'darky',
	'datnigga',
	'deapthroat',
	'death',
	'deepthroat',
	'defecate',
	'dego',
	'demon',
	'desire',
	'deth',
	'devil',
	'devilworshipper',
	'dickbrain',
	'dickforbrains',
	'dickhead',
	'dickless',
	'dicklick',
	'dicklicker',
	'dickman',
	'dickwad',
	'dickweed',
	'diddle',
	'dike',
	'dildo',
	'dingleberry',
	'dipshit',
	'dipstick',
	'dix',
	'dixiedike',
	'dixiedyke',
	'doggiestyle',
	'doggystyle',
	'doodoo',
	'doo-doo',
	'doom',
	'dope',
	'dragqueen',
	'dragqween',
	'dripdick',
	'drug',
	'drunk',
	'drunken',
	'dumb',
	'dumbass',
	'dumbbitch',
	'dumbfuck',
	'dyefly',
	'dyke',
	'easyslut',
	'eatballs',
	'eatme',
	'eatpussy',
	'ecstacy',
	'ejaculate',
	'ejaculated',
	'ejaculating ',
	'ejaculation',
	'enema',
	'enemy',
	'erect',
	'erection',
	'ero',
	'escort',
	'evl',
	'execute',
	'executed',
	'execution',
	'executioner',
	'explosion',
	'facefucker',
	'fag',
	'fagging',
	'faggot',
	'fagot',
	'failure',
	'fairies',
	'fairy',
	'fannyfucker',
	'fastfuck',
	'fatah',
	'fatass',
	'fatfuck',
	'fatfucker',
	'fatso',
	'fckcum',
	'feces',
	'felatio',
	'felcher',
	'felching',
	'fellatio',
	'feltch',
	'feltcher',
	'feltching',
	'fetish',
	'fingerfood',
	'fingerfuck ',
	'fingerfucked ',
	'fingerfucker ',
	'fingerfuckers',
	'fingerfucking ',
	'fire',
	'firing',
	'fister',
	'fistfuck',
	'fistfucked ',
	'fistfucker ',
	'fistfucking ',
	'fisting',
	'flange',
	'flatulence',
	'floo',
	'flydie',
	'flydye',
	'fok',
	'fondle',
	'footaction',
	'footfuck',
	'footfucker',
	'footlicker',
	'footstar',
	'foreskin',
	'forni',
	'fornicate',
	'foursome',
	'fourtwenty',
	'fraud',
	'freakfuck',
	'freakyfucker',
	'freefuck',
	'fubar',
	'fuc',
	'fucck',
	'fuck',
	'fucka',
	'fuckable',
	'fuckbag',
	'fuckbuddy',
	'fucked',
	'fuckedup',
	'fucker',
	'fuckers',
	'fuckface',
	'fuckfest',
	'fuckfreak',
	'fuckfriend',
	'fuckhead',
	'fuckher',
	'fuckin',
	'fuckina',
	'fucking',
	'fuckingbitch',
	'fuckinnuts',
	'fuckinright',
	'fuckit',
	'fuckknob',
	'fuckme ',
	'fuckmehard',
	'fuckmonkey',
	'fuckoff',
	'fuckpig',
	'fucks',
	'fucktard',
	'fuckwhore',
	'fuckyou',
	'fudgepacker',
	'fugly',
	'fuk',
	'fuks',
	'funeral',
	'funfuck',
	'fungus',
	'fuuck',
	'gangbang',
	'gangbanged ',
	'gangbanger',
	'gangsta',
	'gatorbait',
	'gaymuthafuckinwhore',
	'gaysex ',
	'geez',
	'geezer',
	'geni',
	'genital',
	'german',
	'getiton',
	'ginzo',
	'gipp',
	'girls',
	'givehead',
	'glazeddonut',
	'gob',
	'god',
	'godammit',
	'goddamit',
	'goddammit',
	'goddamn',
	'goddamned',
	'goddamnes',
	'goddamnit',
	'goddamnmuthafucker',
	'goldenshower',
	'gonorrehea',
	'gonzagas',
	'gook',
	'gotohell',
	'goy',
	'goyim',
	'greaseball',
	'gringo',
	'groe',
	'grostulation',
	'gubba',
	'gummer',
	'gun',
	'gyp',
	'gypo',
	'gypp',
	'gyppie',
	'gyppo',
	'gyppy',
	'hamas',
	'handjob',
	'hapa',
	'harder',
	'hardon',
	'harem',
	'headfuck',
	'headlights',
	'hebe',
	'heeb',
	'hell',
	'henhouse',
	'heroin',
	'herpes',
	'heterosexual',
	'hijack',
	'hijacker',
	'hijacking',
	'hillbillies',
	'hindoo',
	'hiscock',
	'hitler',
	'hitlerism',
	'hitlerist',
	'hiv',
	'hobo',
	'hodgie',
	'hoes',
	'holestuffer',
	'homicide',
	'homo',
	'homobangers',
	'homosexual',
	'honger',
	'honk',
	'honkers',
	'honkey',
	'honky',
	'hook',
	'hookers',
	'hooters',
	'hore',
	'hork',
	'horn',
	'horney',
	'horniest',
	'horny',
	'horseshit',
	'hosejob',
	'hoser',
	'hostage',
	'hotdamn',
	'hotpussy',
	'hottotrot',
	'hummer',
	'husky',
	'hussy',
	'hustler',
	'hymen',
	'hymie',
	'iblowu',
	'idiot',
	'ikey',
	'incest',
	'insest',
	'intercourse',
	'interracial',
	'intheass',
	'inthebuff',
	'jackass',
	'jackoff',
	'jackshit',
	'jacktheripper',
	'jade',
	'jap',
	'japcrap',
	'jebus',
	'jerkoff',
	'jesuschrist',
	'jewish',
	'jiga',
	'jigaboo',
	'jigg',
	'jigga',
	'jiggabo',
	'jigger',
	'jiggy',
	'jihad',
	'jijjiboo',
	'jimfish',
	'jism',
	'jiz ',
	'jizim',
	'jizjuice',
	'jizm ',
	'jizz',
	'jizzim',
	'jizzum',
	'juggalo',
	'jugs',
	'junglebunny',
	'kaffer',
	'kaffir',
	'kaffre',
	'kafir',
	'kanake',
	'kigger',
	'kike',
	'kinky',
	'kissass',
	'kkk',
	'knockers',
	'kock',
	'kondum',
	'koon',
	'kotex',
	'krap',
	'krappy',
	'kum',
	'kumbubble',
	'kumbullbe',
	'kummer',
	'kumming',
	'kumquat',
	'kums',
	'kunilingus',
	'kunnilingus',
	'kunt',
	'kyke',
	'lactate',
	'lapdance',
	'lesbain',
	'lesbayn',
	'lesbian',
	'lesbin',
	'lesbo',
	'lez',
	'lezbe',
	'lezbefriends',
	'lezbo',
	'lezz',
	'lezzo',
	'liberal',
	'libido',
	'licker',
	'lickme',
	'limey',
	'limpdick',
	'limy',
	'lingerie',
	'livesex',
	'loadedgun',
	'lolita',
	'looser',
	'lotion',
	'lovebone',
	'lovegoo',
	'lovegun',
	'lovejuice',
	'lovemuscle',
	'lovepistol',
	'loverocket',
	'lowlife',
	'lsd',
	'lubejob',
	'luckycammeltoe',
	'lugan',
	'macaca',
	'magicwand',
	'mams',
	'manhater',
	'manpaste',
	'mastabate',
	'mastabater',
	'masterbate',
	'masterblaster',
	'mastrabator',
	'masturbate',
	'masturbating',
	'mattressprincess',
	'meatbeatter',
	'meatrack',
	'meth',
	'mgger',
	'mggor',
	'mickeyfinn',
	'mideast',
	'milf',
	'mockey',
	'mockie',
	'mocky',
	'mofo',
	'moky',
	'moles',
	'molest',
	'molestation',
	'molester',
	'molestor',
	'moneyshot',
	'mooncricket',
	'moron',
	'moslem',
	'mosshead',
	'mothafuck',
	'mothafucka',
	'mothafuckaz',
	'mothafucked ',
	'mothafucker',
	'mothafuckin',
	'mothafucking ',
	'mothafuckings',
	'motherfuck',
	'motherfucked',
	'motherfucker',
	'motherfuckin',
	'motherfucking',
	'motherfuckings',
	'motherlovebone',
	'muff',
	'muffdive',
	'muffdiver',
	'muffindiver',
	'mufflikcer',
	'mulatto',
	'munt',
	'murder',
	'murderer',
	'naked',
	'narcotic',
	'nastybitch',
	'nastyho',
	'nastyslut',
	'nastywhore',
	'nazi',
	'necro',
	'negro',
	'negroes',
	'negroid',
	'nig',
	'niger',
	'nigerian',
	'nigerians',
	'nigg',
	'nigga',
	'niggah',
	'niggaracci',
	'niggard',
	'niggarded',
	'niggarding',
	'niggardliness',
	'niggardly',
	'niggards',
	'niggaz',
	'nigger',
	'niggerhead',
	'niggerhole',
	'niggers',
	'niggle',
	'niggled',
	'niggles',
	'niggling',
	'nigglings',
	'niggor',
	'niggur',
	'niglet',
	'nignog',
	'nigr',
	'nigra',
	'nigre',
	'nipplering',
	'nittit',
	'nlgger',
	'nlggor',
	'nofuckingway',
	'nookey',
	'nookie',
	'nude',
	'nudger',
	'nuke',
	'nutfucker',
	'nymph',
	'ontherag',
	'orga',
	'orgasim ',
	'orgasm',
	'orgies',
	'orgy',
	'paki',
	'palesimian',
	'panti',
	'panties',
	'payo',
	'pearlnecklace',
	'pecker',
	'peckerwood',
	'peepshow',
	'peepshpw',
	'pendy',
	'penetration',
	'peni5',
	'penthouse',
	'perv',
	'phonesex',
	'phuk',
	'phuked',
	'phuking',
	'phukked',
	'phukking',
	'phungky',
	'phuq',
	'pi55',
	'picaninny',
	'piccaninny',
	'pickaninny',
	'piker',
	'pikey',
	'piky',
	'pimp',
	'pimped',
	'pimper',
	'pimpjuic',
	'pimpjuice',
	'pimpsimp',
	'pindick',
	'piss',
	'pissed',
	'pisser',
	'pisses ',
	'pisshead',
	'pissin ',
	'pissing',
	'pissoff ',
	'pistol',
	'pixy',
	'playboy',
	'playgirl',
	'pocha',
	'pocho',
	'pocketpool',
	'pohm',
	'polack',
	'pom',
	'pommie',
	'pommy',
	'poon',
	'poontang',
	'pooperscooper',
	'poorwhitetrash',
	'popimp',
	'porchmonkey',
	'porn',
	'pornflick',
	'pornking',
	'porno',
	'pornography',
	'pornprincess',
	'poverty',
	'premature',
	'pric',
	'prick',
	'prickhead',
	'primetime',
	'propaganda',
	'prostitute',
	'protestant',
	'pu55i',
	'pu55y',
	'pube',
	'pubiclice',
	'pud',
	'pudboy',
	'pudd',
	'puddboy',
	'puke',
	'puntang',
	'purinapricness',
	'puss',
	'pussie',
	'pussies',
	'pussy',
	'pussycat',
	'pussyeater',
	'pussyfucker',
	'pussylicker',
	'pussylips',
	'pussylover',
	'pussypounder',
	'pusy',
	'quashie',
	'queef',
	'queer',
	'quickie',
	'quim',
	'ra8s',
	'rabbi',
	'racial',
	'racist',
	'radical',
	'radicals',
	'raghead',
	'rape',
	'raped',
	'raper',
	'rapist',
	'rearend',
	'rearentry',
	'redlight',
	'redneck',
	'reefer',
	'reestie',
	'refugee',
	'reject',
	'remains',
	'rentafuck',
	'republican',
	'rere',
	'retard',
	'retarded',
	'ribbed',
	'rigger',
	'rimjob',
	'rimming',
	'robber',
	'roundeye',
	'russki',
	'russkie',
	'sadis',
	'sadom',
	'samckdaddy',
	'sandm',
	'sandnigger',
	'satan',
	'scag',
	'scallywag',
	'scat',
	'schlong',
	'screw',
	'screwyou',
	'scrotum',
	'scum',
	'seppo',
	'servant',
	'sex',
	'sexed',
	'sexfarm',
	'sexhound',
	'sexhouse',
	'sexing',
	'sexkitten',
	'sexpot',
	'sexslave',
	'sextogo',
	'sextoy',
	'sextoys',
	'sexual',
	'sexually',
	'sexwhore',
	'sexy',
	'sexymoma',
	'sexy-slim',
	'shag',
	'shaggin',
	'shagging',
	'shat',
	'shav',
	'shawtypimp',
	'sheeney',
	'shhit',
	'shinola',
	'shit',
	'shitcan',
	'shitdick',
	'shite',
	'shiteater',
	'shited',
	'shitface',
	'shitfaced',
	'shitfit',
	'shitforbrains',
	'shitfuck',
	'shitfucker',
	'shitfull',
	'shithapens',
	'shithappens',
	'shithead',
	'shithouse',
	'shiting',
	'shitlist',
	'shitola',
	'shitoutofluck',
	'shits',
	'shitstain',
	'shitted',
	'shitter',
	'shitting',
	'shitty',
	'shooting',
	'shortfuck',
	'showtime',
	'sissy',
	'sixsixsix',
	'sixtynine',
	'sixtyniner',
	'skank',
	'skankbitch',
	'skankfuck',
	'skankwhore',
	'skanky',
	'skankybitch',
	'skankywhore',
	'skinflute',
	'skum',
	'skumbag',
	'slant',
	'slanteye',
	'slapper',
	'slaughter',
	'slav',
	'slave',
	'slavedriver',
	'sleezebag',
	'sleezeball',
	'slideitin',
	'slime',
	'slimeball',
	'slimebucket',
	'slopehead',
	'slopey',
	'slopy',
	'slut',
	'sluts',
	'slutt',
	'slutting',
	'slutty',
	'slutwear',
	'slutwhore',
	'smack',
	'smackthemonkey',
	'smut',
	'snatch',
	'snatchpatch',
	'snigger',
	'sniggered',
	'sniggering',
	'sniggers',
	'sniper',
	'snot',
	'snowback',
	'snownigger',
	'sob',
	'sodom',
	'sodomise',
	'sodomite',
	'sodomize',
	'sodomy',
	'sonofabitch',
	'sonofbitch',
	'sooty',
	'sos',
	'soviet',
	'spaghettibender',
	'spaghettinigger',
	'spank',
	'spankthemonkey',
	'spermbag',
	'spermhearder',
	'spermherder',
	'spic',
	'spick',
	'spig',
	'spigotty',
	'spik',
	'spitter',
	'splittail',
	'spooge',
	'spreadeagle',
	'spunk',
	'spunky',
	'squaw',
	'stagg',
	'stiffy',
	'strapon',
	'stripclub',
	'stroke',
	'stroking',
	'stupidfuck',
	'stupidfucker',
	'suck',
	'suckdick',
	'sucker',
	'suckme',
	'suckmyass',
	'suckmydick',
	'suckmytit',
	'suckoff',
	'suicide',
	'swallower',
	'swastika',
	'taboo',
	'taff',
	'tantra',
	'tarbaby',
	'tard',
	'teat',
	'terror',
	'terrorist',
	'thicklips',
	'thirdeye',
	'thirdleg',
	'threesome',
	'threeway',
	'timbernigger',
	'tit',
	'titbitnipply',
	'titfuck',
	'titfucker',
	'titfuckin',
	'titjob',
	'titlicker',
	'titlover',
	'tits',
	'tittie',
	'titties',
	'titty',
	'tnt',
	'toilet',
	'tongethruster',
	'tongue',
	'tonguethrust',
	'tonguetramp',
	'tortur',
	'torture',
	'tosser',
	'towelhead',
	'trailertrash',
	'tramp',
	'trannie',
	'tranny',
	'transexual',
	'transsexual',
	'transvestite',
	'triplex',
	'trisexual',
	'trojan',
	'trots',
	'tuckahoe',
	'tunneloflove',
	'turd',
	'turnon',
	'twat',
	'twink',
	'twinkie',
	'twobitwhore',
	'uck',
	'unfuckable',
	'upskirt',
	'uptheass',
	'upthebutt',
	'usama',
	'vatican',
	'vibr',
	'vibrater',
	'vibrator',
	'vietcong',
	'virgin',
	'virginbreaker',
	'wab',
	'wank',
	'wanker',
	'wanking',
	'waysted',
	'weenie',
	'weewee',
	'welcher',
	'welfare',
	'wetb',
	'wetback',
	'wetspot',
	'whacker',
	'whash',
	'whigger',
	'whiskey',
	'whiskeydick',
	'whiskydick',
	'whitenigger',
	'whitetrash',
	'whitey',
	'whiz',
	'whop',
	'whore',
	'whorefucker',
	'whorehouse',
	'wigger',
	'williewanker',
	'wn',
	'wog',
	'wop',
	'wtf',
	'wuss',
	'wuzzie',
	'xtc',
	'xxx',
	'yankee',
	'yellowman',
	'zigabo',
	'zipperhead',
	'ghostbusters',
];

export default badwords;
